<template>
  <div>
    <div
      class="vx-row"
      v-if="
        typeof personas !== 'undefined' && personas.length == 0 && !iniciando
      "
    >
      <vs-alert title="Debes dar de alta personas" color="danger" active="true">
        Antes de inscribirte tú o a tus familiares a cualquier actividad
        <a style="cursor: pointer" @click="$router.push({ path: 'hijos' })"
          >ve a la ficha de personas y dalos de alta</a
        >.
        <br />
        <br />
        <vs-button
          color="danger"
          @click="$router.push({ path: 'hijos' })"
          type="filled"
          >Dar de alta una nueva persona</vs-button
        >
      </vs-alert>
    </div>

    <div
      class="vx-col w-full mb-base"
      v-else-if="
        typeof getter_user.telefono === 'undefined' ||
        getter_user.telefono == '' ||
        getter_user.telefono == null
      "
    >
      <div v-if="getter_user.length !== 0">
        <vs-alert
          title="¡Necesitamos tu teléfono!"
          color="warning"
          active="true"
        >
          No nos has indicado un teléfono. Necesitamos tu teléfono para
          contactar contigo si hay alguna incidencia. Por favor,
          <a
            @click="$router.push({ path: 'configuracion' })"
            style="cursor: pointer"
            >ves a tu ficha de usuario</a
          >
          y rellena el campo teléfono.
        </vs-alert>
      </div>
    </div>
    <div class="vx-row" v-else>
      <div class="vx-col w-full mb-base">
        <div class="content-area__heading pr-4 border-0">
          <!--h2 v-if="nodo !== undefined" class="mb-1" style="display: inline-block">
            <span v-if="nodo.icono !== undefined">
              <font-awesome-icon
                v-if="nodo.icono.split(' ').length > 1"
                :icon="[nodo.icono.split(' ')[0],nodo.icono.split(' ')[1].replace('fa-','')]"
                />
            </span>
            {{nodo.titulo}}
          </h2-->
          <div class="ruticas">
            <ruta
              class="rutas"
              :nodos="nodos"
              :nodo_id="nodo_id"
              @ir_al_padre="ir_al_nodo"
            ></ruta>
          </div>
        </div>
        <div v-for="nodo in nodos" :key="nodo.id">
          <div v-if="nodo.id == nodo_id">
            <vx-card style="margin-top: 20px" class="contratar">
              <h4 class="titulo-superior">
                <span v-if="nodo.icono !== undefined">
                  <font-awesome-icon
                    v-if="nodo.icono.split(' ').length > 1"
                    :icon="[
                      nodo.icono.split(' ')[0],
                      nodo.icono.split(' ')[1].replace('fa-', ''),
                    ]"
                  />
                </span>
                {{ nodo.titulo }}
              </h4>
              <div v-if="nodo.comprable">
                <vs-card style="margin: 5px; width: calc(100% - 10px)">
                  <vs-row>
                    <vs-col vs-w="6" vs-sm="12">
                      <h2>Contratar</h2>
                      <div class="duracion">
                        Duración del curso:
                        {{
                          fecha_bonita(parametro_padre(nodo.id, "fecha_inicio"))
                        }}
                        -
                        {{
                          fecha_bonita(parametro_padre(nodo.id, "fecha_fin"))
                        }}
                      </div>
                      <p v-html="nodo.descripcion"></p>

                      <span
                        class="precios"
                        v-if="
                          (parametro_padre(nodo.id, 'fecha_apertura') == '' ||
                            parametro_padre(nodo.id, 'fecha_apertura') <=
                              hoy()) &&
                          (parametro_padre(nodo.id, 'fecha_cierre') == '' ||
                            parametro_padre(nodo.id, 'fecha_cierre') >= hoy())
                        "
                      >
                        <div
                          v-if="precio_final(nodo.id)[1] != ''"
                          class="precio_descontado"
                        >
                          {{ precio_final(nodo.id)[1] }} €
                          <span>Descuento inicial</span>
                        </div>
                        <div
                          v-if="precio_final(nodo.id)[2] != ''"
                          class="precio_penalizado"
                        >
                          {{ precio_final(nodo.id)[2] }} €
                          <span>Última hora</span>
                        </div>
                        <div
                          v-if="
                            precio_final(nodo.id)[1] != '' ||
                            precio_final(nodo.id)[2] != ''
                          "
                          class="precio_original"
                        >
                          {{ precio_final(nodo.id)[0] }} €
                        </div>
                        <div v-else class="precio">
                          {{ precio_final(nodo.id)[0] }} €
                        </div>
                      </span>
                      <span v-else style="margin: 15px">
                        <vs-alert
                          title="Estas fuera del tiempo"
                          active="true"
                          color="danger"
                        >
                          <span
                            v-if="
                              parametro_padre(nodo.id, 'fecha_cierre') == ''
                            "
                          >
                            Estas fuera del tiempo para poder contratar este
                            curso (Todavía no es el
                            {{ parametro_padre(nodo.id, "fecha_apertura") }})
                          </span>
                          <span
                            v-else-if="
                              parametro_padre(nodo.id, 'fecha_apertura') == ''
                            "
                          >
                            Estas fuera del tiempo para poder contratar este
                            curso (Ya pasó el
                            {{ parametro_padre(nodo.id, "fecha_cierre") }})
                          </span>
                          <span v-else>
                            Estas fuera del tiempo para poder contratar este
                            curso (Entre el
                            {{ parametro_padre(nodo.id, "fecha_apertura") }} y
                            {{ parametro_padre(nodo.id, "fecha_cierre") }})
                          </span>
                        </vs-alert>
                      </span>
                    </vs-col>
                    <vs-col vs-w="6" vs-sm="12">
                      <div
                        v-if="descripciones.length > 0"
                        class="descripciones"
                      >
                        <div
                          v-for="(descripcion, index) in descripciones"
                          :key="index"
                          class="descripcion"
                        >
                          <h4>{{ descripcion.titulo }}</h4>
                          <p>{{ descripcion.descripcion }}</p>
                        </div>
                      </div>
                    </vs-col>
                  </vs-row>
                </vs-card>

                <vs-row class="hijos_del_padre" v-if="carrito.length > 0">
                  <vs-col
                    style="margin-bottom: 10px"
                    type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                    vs-sm="12"
                    class="hijo_del_padre"
                    v-for="(reserva_nodo, index) in carrito"
                    :key="index"
                  >
                    <vs-card
                      style="margin: 5px; width: calc(100% - 10px)"
                      v-if="reserva_nodo.nodo_id == nodo_id"
                    >
                      <div slot="header">
                        <vs-avatar />
                        <h3
                          style="
                            vertical-align: top;
                            display: inline-block;
                            line-height: 43px;
                            margin-left: 10px;
                          "
                        >
                          {{ reserva_nodo.hijo.nombre }}
                          {{ reserva_nodo.hijo.apellidos }}
                        </h3>
                      </div>
                      <div
                        v-if="
                          typeof reserva_nodo.hijo.fechaNacimiento !== null &&
                          reserva_nodo.hijo.fechaNacimiento != '' &&
                          typeof reserva_nodo.hijo.fechaNacimiento.split(
                            '-'
                          )[0] !== 'undefined' &&
                          (edad_minima_final <
                            reserva_nodo.hijo.fechaNacimiento.split('-')[0] ||
                            edad_maxima_final >
                              reserva_nodo.hijo.fechaNacimiento.split('-')[0])
                        "
                      >
                        <vs-alert color="danger" title="Alerta" active="true">
                          <div>
                            Esta actividad no está disponible para esta edad.
                          </div>

                          <div
                            v-if="
                              edad_minima_final != 99999 &&
                              edad_maxima_final != ''
                            "
                          >
                            Está permitido para nacidos entre
                            {{ edad_maxima_final }} y {{ edad_minima_final }}.
                          </div>
                          <div v-else-if="edad_minima_final != 99999">
                            Está permitido para nacidos hasta
                            {{ edad_minima_final }}.
                          </div>
                          <div v-else-if="edad_maxima_final != ''">
                            Está permitido para nacidos a partir
                            {{ edad_maxima_final }}.
                          </div>
                        </vs-alert>
                      </div>
                      <div
                        v-else-if="
                          acceso == 0 ||
                          (acceso == 1 && reserva_nodo.hijo.abonado) ||
                          (acceso == 2 && !reserva_nodo.hijo.abonado)
                        "
                      >
                        <!-- no tiene reservado el curso, por tanto mostramos estos checkbox, para que los rellenen -->

                        <div v-if="reserva_nodo.extras.length > 0">
                          <vs-table>
                            <template slot="thead">
                              <vs-th>Concepto</vs-th>
                              <vs-th>Precio</vs-th>
                              <vs-th>Cantidad</vs-th>
                              <vs-th>Total</vs-th>
                            </template>
                            <template>
                              <vs-tr state="dark">
                                <vs-td>
                                  {{ reserva_nodo.nodo.titulo }}
                                </vs-td>
                                <vs-td>
                                  {{ precio_final(nodo.id)[0] }} €
                                </vs-td>
                                <vs-td style="text-align: center"> 1 </vs-td>
                                <vs-td>
                                  {{ precio_final(nodo.id)[0] }} €
                                </vs-td>
                              </vs-tr>
                              <vs-tr
                                v-for="(
                                  extra, extra_index
                                ) in reserva_nodo.extras"
                                :key="extra_index"
                              >
                                <vs-td>
                                  {{ extra.extra.concepto }}
                                </vs-td>
                                <vs-td> {{ extra.extra.precio }} € </vs-td>
                                <vs-td>
                                  <vs-input-number
                                    style="max-width: 50px"
                                    min="0"
                                    :max="
                                      extra.extra.permitecantidad == 0
                                        ? 1
                                        : extra.extra.limite
                                        ? extra.extra.limite
                                        : 99999999999
                                    "
                                    :value="
                                      reserva_nodo.extras[extra_index].cantidad
                                    "
                                    @input="
                                      extra_cantidad(index, extra_index, $event)
                                    "
                                    :disabled="
                                      reserva_nodo.reserva.estado != -1
                                    "
                                  />
                                </vs-td>
                                <vs-td> {{ extra.precio_total }} € </vs-td>
                              </vs-tr>
                              <vs-tr state="dark">
                                <vs-td> TOTAL </vs-td>
                                <vs-td> </vs-td>
                                <vs-td> </vs-td>
                                <vs-td>
                                  {{
                                    precio_final(nodo.id)[0] +
                                    reserva_nodo.precio_extras
                                  }}
                                  €
                                </vs-td>
                              </vs-tr>
                            </template>
                          </vs-table>
                        </div>
                        <hr v-if="reserva_nodo.extras.length > 0" />
                        <vs-textarea
                          @change="observaciones(index)"
                          :label="observaciones_nodo"
                          v-model="reserva_nodo.observaciones"
                          lazy
                          :disabled="reserva_nodo.cantidad > 0 ? true : false"
                          debounce="500"
                        ></vs-textarea>
                        <div v-show="false">
                          <form
                            data-vv-scope="form"
                            ref="form"
                            class="datos-bancarios"
                          >
                            <h4>
                              Este producto se paga por domiciliación bancaria
                            </h4>
                            <h5>Introduce los datos de tu cuenta bancaria</h5>
                            <vs-row>
                              <vs-col
                                vs-w="6"
                                vs-xs="12"
                                vs-sm="12"
                                vs-lg="4"
                                style="margin-top: 5px"
                              >
                                <vs-input
                                  :disabled="
                                    !(
                                      getter_user &&
                                      reserva_nodo &&
                                      parametro_padre(
                                        reserva_nodo.nodo_id,
                                        'tpv_id'
                                      ) === 3 &&
                                      (!getter_user.titular ||
                                        !getter_user.nif ||
                                        getter_user.nif.length != 9 ||
                                        getter_user.titular.length < 3)
                                    )
                                  "
                                  :danger="errors.has('form.titular')"
                                  :danger-text="errors.first('form.titular')"
                                  label="Titular"
                                  type="titular"
                                  v-validate="'required|min:3|max:30'"
                                  data-vv-as="titular"
                                  v-model="titular"
                                  name="titular"
                                  ref="titular"
                                  :class="{
                                    input: true,
                                    'is-danger': errors.has('form.titular'),
                                  }"
                                  style="
                                    width: 100%;
                                    padding-right: 10px;
                                    max-width: 240px;
                                  "
                                />
                              </vs-col>
                              <vs-col
                                vs-w="6"
                                vs-xs="12"
                                vs-sm="12"
                                vs-lg="4"
                                style="margin-top: 5px"
                              >
                                <vs-input
                                  :disabled="
                                    !(
                                      getter_user &&
                                      reserva_nodo &&
                                      parametro_padre(
                                        reserva_nodo.nodo_id,
                                        'tpv_id'
                                      ) === 3 &&
                                      (!getter_user.nif ||
                                        getter_user.nif.length != 9)
                                    )
                                  "
                                  :danger="errors.has('form.nif')"
                                  :danger-text="errors.first('form.nif')"
                                  label="NIF/NIE"
                                  type="nif"
                                  v-validate="'required|min:9|max:9'"
                                  data-vv-as="nif"
                                  v-model="nif"
                                  name="nif"
                                  ref="nif"
                                  v-mask="['X#######A', 'A#######A']"
                                  :class="{
                                    input: true,
                                    'is-danger': errors.has('form.nif'),
                                  }"
                                  style="
                                    width: 100%;
                                    padding-right: 10px;
                                    max-width: 240px;
                                  "
                                  v-on:keyup="upper()"
                                />
                              </vs-col>
                              <vs-col
                                vs-w="6"
                                vs-xs="12"
                                vs-sm="12"
                                vs-lg="8"
                                style="margin-top: 5px"
                              >
                                <vs-input
                                  :disabled="
                                    !(
                                      getter_user &&
                                      reserva_nodo &&
                                      parametro_padre(
                                        reserva_nodo.nodo_id,
                                        'tpv_id'
                                      ) === 3 &&
                                      (!getter_user.nif ||
                                        getter_user.nif.length != 9)
                                    )
                                  "
                                  :danger="errors.has('form.iban')"
                                  danger-text="El IBAN debe tener el formato correcto"
                                  label="IBAN"
                                  type="iban"
                                  v-validate="'required|min:26|max:26'"
                                  data-vv-as="IBAN"
                                  v-model="iban"
                                  name="iban"
                                  ref="iban"
                                  v-mask="['E!S## #### #### ## ########']"
                                  placeholder="ESXX XXXX XXXX XX XXXXXXXX"
                                  :class="{
                                    input: true,
                                    'is-danger': errors.has('form.iban'),
                                  }"
                                  style="min-width: 230px"
                                />
                              </vs-col>
                            </vs-row>
                          </form>
                        </div>
                        <div>
                          <vs-checkbox
                            :value="reserva_nodo.rpgd"
                            @input="rpgd(index)"
                            :disabled="reserva_nodo.cantidad > 0 ? true : false"
                            style="margin-top: 10px; display: inline-block"
                          ></vs-checkbox>
                          <span style="vertical-align: super">
                            He leído y acepto el
                            <a
                              href="http://www.stadiumcasablanca.com/aviso-legal/"
                              target="_blank"
                              >aviso legal</a
                            >,
                            <a
                              href="http://www.stadiumcasablanca.com/terminos-contratacion/"
                              target="_blank"
                              >los términos</a
                            >
                            y la
                            <a
                              href="https://stadiumcasablanca.com/politica-de-privacidad-club-deportivo-stadium-casablanca/"
                              target="_blank"
                              >política de privacidad</a
                            >
                            <span style="color: red"> *</span>
                          </span>
                        </div>
                        <ConsentimientoFotografias
                          :index="index"
                          :fotos="reserva_nodo.fotos ? true : false"
                          :disabled="reserva_nodo.cantidad > 0 ? true : false"
                        />
                        <MontanaAvisoLegal
                          :index="index"
                          :reserva_nodo="reserva_nodo"
                          :montana_aviso_legal="
                            parseInt(
                              parametro_padre(nodo.id, 'montana_aviso_legal')
                            )
                          "
                        />
                        <NumeroGirDni
                          :index="index"
                          :reserva_nodo="reserva_nodo"
                          :numero_gir_dni="
                            parseInt(parametro_padre(nodo.id, 'numero_gir_dni'))
                          "
                        />
                      </div>
                      <div v-else>
                        <vs-alert color="danger" title="Alerta" active="true">
                          <span v-if="acceso == 1"
                            >Actividad exclusiva para abonados</span
                          >
                          <span v-if="acceso == 2"
                            >Actividad exclusiva para no abonados</span
                          >
                        </vs-alert>
                      </div>

                      <div
                        slot="footer"
                        v-if="
                          acceso == 0 ||
                          (acceso == 1 && reserva_nodo.hijo.abonado) ||
                          (acceso == 2 && !reserva_nodo.hijo.abonado)
                        "
                      >
                        <vs-row vs-justify="flex-end">
                          <span
                            v-if="
                              (parametro_padre(nodo.id, 'fecha_apertura') ==
                                '' ||
                                parametro_padre(nodo.id, 'fecha_apertura') <=
                                  hoy()) &&
                              (parametro_padre(nodo.id, 'fecha_cierre') == '' ||
                                parametro_padre(nodo.id, 'fecha_cierre') >=
                                  hoy())
                            "
                          >
                            <!--span v-if=" parametro_padre(nodo.id,'fecha_apertura') < hoy() && parametro_padre(nodo.id,'fecha_cierre') > hoy() "-->

                            <span v-if="reserva_nodo.reserva.estado == -1">
                              <span v-if="reserva_nodo.cantidad == 0">
                                <vs-button
                                  v-if="
                                    lista_tpv_ids.length === 0 ||
                                    lista_tpv_ids.includes(
                                      parametro_padre(
                                        reserva_nodo.nodo.id,
                                        'tpv_id'
                                      )
                                    )
                                  "
                                  style="margin-bottom: 35px"
                                  class="btn-contratar"
                                  color="primary"
                                  :disabled="
                                    !reserva_nodo.rpgd ||
                                    (parametro_padre(
                                      nodo.id,
                                      'fotosobligatorias'
                                    ) === 1 &&
                                      !reserva_nodo.fotos) ||
                                    (parametro_padre(
                                      nodo.id,
                                      'montana_aviso_legal'
                                    ) === 1 &&
                                      !reserva_nodo.montana_aviso_legal_checked) ||
                                    (parametro_padre(
                                      nodo.id,
                                      'numero_gir_dni'
                                    ) === 1 &&
                                      !reserva_nodo.numero_gir_dni_checked)
                                  "
                                  @click="
                                    cantidad(index, 1, reserva_nodo.nodo_id)
                                  "
                                >
                                  Añadir al carrito
                                </vs-button>
                                <vs-alert
                                  v-else
                                  color="danger"
                                  title="Alerta"
                                  active="true"
                                  class="message-alert-incompatible"
                                >
                                  Este producto es incompatible con el producto
                                  del carrito. Para comprar ambos, debes comprar
                                  uno, y luego otro.
                                </vs-alert>
                              </span>
                              <vs-button
                                v-if="reserva_nodo.cantidad == 1"
                                style="margin-bottom: 35px"
                                class="btn-contratar"
                                color="danger"
                                :disabled="!reserva_nodo.rpgd"
                                @click="
                                  cantidad(index, 0, reserva_nodo.nodo_id)
                                "
                              >
                                Eliminar del carrito
                              </vs-button>
                            </span>
                            <span v-else>
                              <span v-if="reserva_nodo.reserva.tpv_id !== 3">
                                <vs-chip
                                  v-if="reserva_nodo.reserva.estado == 0"
                                  color="warning"
                                  style="margin-bottom: 20px"
                                >
                                  <a
                                    :href="
                                      (reserva_nodo.reserva.tpv_id === 2
                                        ? url_tpv_pago_2
                                        : url_tpv_pago_1) +
                                      reserva_nodo.reserva.hash
                                    "
                                    target="_blank"
                                    style="color: white"
                                  >
                                    Pendiente de pago
                                  </a>
                                </vs-chip>
                                <vs-chip
                                  v-if="reserva_nodo.reserva.estado == 1"
                                  color="success"
                                  style="margin-bottom: 20px"
                                  >Curso contratado</vs-chip
                                >
                                <vs-chip
                                  v-if="reserva_nodo.reserva.estado == 2"
                                  color="warning"
                                  style="margin-bottom: 20px"
                                >
                                  <a
                                    :href="
                                      (reserva_nodo.reserva.tpv_id === 2
                                        ? url_tpv_pago_2
                                        : url_tpv_pago_1) +
                                      reserva_nodo.reserva.hash
                                    "
                                    target="_blank"
                                    style="color: white"
                                  >
                                    Pago por confirmar
                                  </a>
                                </vs-chip>
                                <vs-chip
                                  v-if="reserva_nodo.reserva.estado == 3"
                                  color="danger"
                                  style="margin-bottom: 20px"
                                  >Transferencia</vs-chip
                                >
                                <vs-chip
                                  v-if="reserva_nodo.reserva.estado == -1"
                                  color="danger"
                                  style="margin-bottom: 20px"
                                  >Pago fallido</vs-chip
                                >
                                <vs-button
                                  style="
                                    display: inline-block;
                                    margin-left: 5px;
                                  "
                                  v-if="
                                    reserva_nodo.reserva.estado == 0 ||
                                    reserva_nodo.reserva.estado == 2
                                  "
                                  radius
                                  color="warning"
                                  type="border"
                                  icon-pack="feather"
                                  icon="icon-refresh-cw"
                                  size="small"
                                  @click="estado(reserva_nodo.reserva.id)"
                                >
                                </vs-button>
                                <vs-button
                                  style="
                                    display: inline-block;
                                    margin-left: 5px;
                                  "
                                  v-if="
                                    reserva_nodo.reserva.estado == 0 ||
                                    reserva_nodo.reserva.estado == 2
                                  "
                                  radius
                                  color="danger"
                                  type="border"
                                  icon-pack="feather"
                                  icon="icon-x"
                                  size="small"
                                  @click="
                                    eliminar_reserva(reserva_nodo.reserva.id)
                                  "
                                >
                                </vs-button>
                              </span>
                              <span v-else>
                                <vs-chip
                                  color="primary"
                                  style="margin-bottom: 20px"
                                  >Actividad ya contratada</vs-chip
                                >
                              </span>
                            </span>
                          </span>
                        </vs-row>
                      </div>
                    </vs-card>
                  </vs-col>
                </vs-row>
                <div v-else>
                  <vs-alert
                    title="No tienes personas creadas"
                    active="true"
                    color="danger"
                  >
                    Antes de contratar un curso tienes que dar de alta algún
                    componente de tu familia, incluyéndote a ti si procede, en
                    la sección de
                    <a href="#" @click.prevent="$router.push('/hijos')"
                      >Personas</a
                    >
                  </vs-alert>
                </div>

                <vs-row
                  v-if="hijos_del_padre.length > 0 && false"
                  class="hijos_del_padre"
                >
                  <vs-col
                    style="margin-bottom: 10px"
                    type="flex"
                    vs-justify="center"
                    vs-align="center"
                    vs-w="6"
                    vs-sm="12"
                    v-for="hijo in hijos_del_padre"
                    :key="hijo.id"
                    class="hijo_del_padre"
                  >
                    <vs-card style="margin: 5px; width: calc(100% - 10px)">
                      <div slot="header">
                        <vs-avatar />
                        <h3
                          style="
                            vertical-align: top;
                            display: inline-block;
                            line-height: 43px;
                            margin-left: 10px;
                          "
                        >
                          {{ hijo.nombre }} {{ hijo.apellidos }}
                        </h3>
                      </div>
                      <div
                        v-if="
                          acceso == 0 ||
                          (acceso == 1 && hijo.abonado) ||
                          (acceso == 2 && hijo.abonado)
                        "
                      >
                        <!-- no tiene reservado el curso, por tanto mostramos estos checkbox, para que los rellenen -->

                        <span
                          v-if="
                            hijo.reservas.filter((reserva) => {
                              if (reserva.nodo_id == nodo.id) return true;
                              else return false;
                            }).length == 0
                          "
                        >
                          <div>
                            <vs-checkbox
                              v-model="rpgd"
                              style="margin-top: 10px; display: inline-block"
                            ></vs-checkbox>
                            <span style="vertical-align: super">
                              He leído y acepto el
                              <a
                                href="http://www.stadiumcasablanca.com/aviso-legal/"
                                target="_blank"
                                >aviso legal</a
                              >,
                              <a
                                href="http://www.stadiumcasablanca.com/terminos-contratacion/"
                                target="_blank"
                                >los términos</a
                              >
                              y la
                              <a
                                href="http://www.stadiumcasablanca.com/politica-de-privacidad/"
                                target="_blank"
                                >política de privacidad</a
                              >
                            </span>
                          </div>
                          <div>
                            <vs-checkbox
                              v-model="fotos"
                              style="margin-top: 10px; display: inline-block"
                            ></vs-checkbox>
                            <span
                              style="vertical-align: super"
                              @click="mostrar_consentimiento"
                            >
                              Consentimiento expreso de toma de fotografías de
                              la actividad
                            </span>
                          </div>
                          <ConsentimientoFotografias
                            :index="index"
                            :fotos="fotos"
                            disabled="false"
                          />
                          <MontanaAvisoLegal
                            :index="index"
                            :reserva_nodo="reserva_nodo"
                            :montana_aviso_legal="
                              parseInt(
                                parametro_padre(nodo.id, 'montana_aviso_legal')
                              )
                            "
                          />
                          <NumeroGirDni
                            :index="index"
                            :reserva_nodo="reserva_nodo"
                            :numero_gir_dni="
                              parseInt(
                                parametro_padre(nodo.id, 'numero_gir_dni')
                              )
                            "
                          />
                        </span>
                        <span v-else>
                          <div>
                            <vs-checkbox
                              v-model="
                                hijo.reservas.filter((reserva) => {
                                  if (reserva.nodo_id == nodo.id) return true;
                                  else return false;
                                })[0].rpgd
                              "
                              style="margin-top: 10px; display: inline-block"
                              disabled
                              active="true"
                            ></vs-checkbox>
                            <span style="vertical-align: super">
                              He leído y acepto el
                              <a
                                href="http://www.stadiumcasablanca.com/aviso-legal/"
                                target="_blank"
                                >aviso legal</a
                              >,
                              <a
                                href="http://www.stadiumcasablanca.com/terminos-contratacion/"
                                target="_blank"
                                >los términos</a
                              >
                              y la
                              <a
                                href="http://www.stadiumcasablanca.com/politica-de-privacidad/"
                                target="_blank"
                                >política de privacidad</a
                              >
                            </span>
                          </div>
                          <ConsentimientoFotografias
                            :index="index"
                            :fotos="
                              hijo.reservas.filter((reserva) => {
                                if (reserva.nodo_id == nodo.id) return true;
                                else return false;
                              })[0].fotos
                            "
                            disabled="true"
                          />
                          <MontanaAvisoLegal
                            :index="index"
                            :reserva_nodo="reserva_nodo"
                            :montana_aviso_legal="
                              parseInt(
                                parametro_padre(nodo.id, 'montana_aviso_legal')
                              )
                            "
                          />
                          <NumeroGirDni
                            :index="index"
                            :reserva_nodo="reserva_nodo"
                            :numero_gir_dni="
                              parseInt(
                                parametro_padre(nodo.id, 'numero_gir_dni')
                              )
                            "
                          />
                        </span>
                      </div>
                      <div v-else>
                        <vs-alert color="danger" title="Alerta" active="true">
                          <span v-if="acceso == 1"
                            >Actividad exclusiva para abonados</span
                          >
                          <span v-if="acceso == 2"
                            >Actividad exclusiva para no abonados</span
                          >
                        </vs-alert>
                      </div>

                      <div
                        slot="footer"
                        v-if="
                          acceso == 0 ||
                          (acceso == 1 && hijo.abonado) ||
                          (acceso == 2 && hijo.abonado)
                        "
                      >
                        <vs-row vs-justify="flex-end">
                          <span
                            v-if="
                              parametro_padre(nodo.id, 'fecha_apertura') <
                                hoy() &&
                              parametro_padre(nodo.id, 'fecha_cierre') > hoy()
                            "
                          >
                            <vs-button
                              v-if="
                                hijo.reservas.filter((reserva) => {
                                  if (reserva.nodo_id == nodo.id) return true;
                                  else return false;
                                }).length == 0
                              "
                              style="margin-bottom: 35px"
                              class="btn-contratar"
                              color="primary"
                              :disabled="!rpgd"
                              @click.prevent="contratar(hijo.id)"
                            >
                              Contratar
                            </vs-button>
                            <span v-else>
                              <span
                                v-if="
                                  hijo.reservas.filter((reserva) => {
                                    if (reserva.nodo_id == nodo.id) return true;
                                    else return false;
                                  })[0].tpv_id !== 3
                                "
                              >
                                <vs-chip
                                  v-if="
                                    hijo.reservas.filter((reserva) => {
                                      if (reserva.nodo_id == nodo.id)
                                        return true;
                                      else return false;
                                    })[0].estado == 0
                                  "
                                  color="warning"
                                  style="margin-bottom: 20px"
                                >
                                  <a
                                    :href="
                                      (reserva_nodo.reserva.tpv_id === 2
                                        ? url_tpv_pago_2
                                        : url_tpv_pago_1) +
                                      hijo.reservas.filter((reserva) => {
                                        if (reserva.nodo_id == nodo.id)
                                          return true;
                                        else return false;
                                      })[0].hash
                                    "
                                    target="_blank"
                                    style="color: white"
                                  >
                                    Pendiente de pago
                                  </a>
                                </vs-chip>
                                <vs-chip
                                  v-if="
                                    hijo.reservas.filter((reserva) => {
                                      if (reserva.nodo_id == nodo.id)
                                        return true;
                                      else return false;
                                    })[0].estado == 1
                                  "
                                  color="success"
                                  style="margin-bottom: 20px"
                                  >Curso contratado</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    hijo.reservas.filter((reserva) => {
                                      if (reserva.nodo_id == nodo.id)
                                        return true;
                                      else return false;
                                    })[0].estado == 2
                                  "
                                  color="warning"
                                  style="margin-bottom: 20px"
                                  >Pago por confirmar</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    hijo.reservas.filter((reserva) => {
                                      if (reserva.nodo_id == nodo.id)
                                        return true;
                                      else return false;
                                    })[0].estado == 3
                                  "
                                  color="danger"
                                  style="margin-bottom: 20px"
                                  >Transferencia</vs-chip
                                >
                                <vs-chip
                                  v-if="
                                    hijo.reservas.filter((reserva) => {
                                      if (reserva.nodo_id == nodo.id)
                                        return true;
                                      else return false;
                                    })[0].estado == -1
                                  "
                                  color="danger"
                                  style="margin-bottom: 20px"
                                  >Pago fallido</vs-chip
                                >
                              </span>
                              <span v-else>
                                <vs-chip
                                  color="primary"
                                  style="margin-bottom: 20px"
                                  >Actividad ya contratada</vs-chip
                                >
                              </span>
                            </span>
                          </span>
                        </vs-row>
                      </div>
                    </vs-card>
                  </vs-col>
                </vs-row>

                <div v-if="archivos.length">
                  <h4 class="descargas">Descargas</h4>
                  <div class="archivos">
                    <a
                      v-for="archivo in archivos"
                      :key="archivo.id"
                      class="archivo"
                      :href="archivo.url"
                      target="_blank"
                    >
                      <font-awesome-icon
                        v-if="archivo.type == 'application/pdf'"
                        :icon="['fas', 'file-pdf']"
                      />
                      <font-awesome-icon
                        v-if="
                          archivo.type == 'image/jpeg' ||
                          archivo.type == 'image/png'
                        "
                        :icon="['fas', 'file-image']"
                      />
                      <span>{{ archivo.nombre }}</span>
                    </a>
                  </div>
                </div>
              </div>

              <vs-row class="hijos" v-if="hijos !== null">
                <vs-col
                  v-for="hijo in hijos"
                  :key="hijo.id"
                  vs-w="4"
                  vs-xs="12"
                  vs-sm="12"
                >
                  <div
                    class="hijo"
                    :class="{ completo: completo(hijo) }"
                    @click="ir(hijo)"
                    :style="
                      (hijo.acceso == 1 && !acceso_socios) ||
                      (hijo.acceso == 2 && !acceso_nosocios) ||
                      completo(hijo)
                        ? 'cursor: not-allowed'
                        : ''
                    "
                  >
                    <span v-if="hijo.icono !== undefined">
                      <font-awesome-icon
                        v-if="hijo.icono.split(' ').length > 1"
                        :icon="[
                          hijo.icono.split(' ')[0],
                          hijo.icono.split(' ')[1].replace('fa-', ''),
                        ]"
                      />
                    </span>
                    <h4>
                      {{ hijo.titulo }}
                    </h4>
                    <p v-html="hijo.descripcion"></p>
                    <h5 v-if="completo(hijo)">Completo · No quedan plazas</h5>
                    <h5 v-if="hijo.acceso == 1 && !acceso_socios">
                      Actividad exclusiva para socios
                    </h5>
                    <h5 v-if="hijo.acceso == 2 && !acceso_nosocios">
                      Actividad exclusiva para no socios
                    </h5>
                  </div>
                </vs-col>
              </vs-row>
            </vx-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import nodo from "@/components/Nodo.vue";
import ruta from "@/components/Ruta.vue";
import axios from "axios";
import MontanaAvisoLegal from "./components/MontanaAvisoLegal.vue";
import NumeroGirDni from "./components/NumeroGirDni.vue";
import ConsentimientoFotografias from "./components/ConsentimientoFotografias.vue";
export default {
  data() {
    return {
      hijos_del_padre: [],
      nodos: [],
      nodo_id: 1,
      user: {},
      rutas: [],
      iniciando: true,
      nif: "",
      titular: "",
      iban: "",
      //carrito: [],
    };
  },
  components: {
    nodo,
    ruta,
    MontanaAvisoLegal,
    NumeroGirDni,
    ConsentimientoFotografias,
  },
  props: {
    vesalnodoinicial: Boolean,
  },
  mounted() {
    //Primero de todo obtenemos los hijos que tenga este gacho.
    this.$vs.loading({
      type: "default",
    });
    this.get_hijos();
    this.$emit("nodoinicialfalse");
    this.$store.dispatch("get_reservas");
    if (this.getter_user) {
      if (this.getter_user.iban) this.iban = this.getter_user.iban;
      if (this.getter_user.nif) this.nif = this.getter_user.nif;
      if (this.getter_user.titular) this.titular = this.getter_user.titular;
    }
    this.$vs.loading.close();
  },
  watch: {
    vesalnodoinicial(to) {
      if (to) {
        this.ir_al_nodo(1);
        this.$emit("nodoinicialfalse");
      }
    },
  },
  computed: {
    ...mapGetters([
      "url_tpv_pago",
      "url_tpv_pago_1",
      "url_tpv_pago_2",
      "carrito",
      "personas",
      "getter_user",
    ]),
    edad_minima_final() {
      var edad_minima = this.parametro_padre(this.nodo_id, "edad_minima");
      if (edad_minima == "") edad_minima = 99999;
      return edad_minima;
    },
    edad_maxima_final() {
      var edad_maxima = this.parametro_padre(this.nodo_id, "edad_maxima");
      if (edad_maxima == "") edad_maxima = 0;
      return edad_maxima;
    },
    observaciones_nodo() {
      var observaciones = this.parametro_padre(this.nodo_id, "observaciones");
      return observaciones;
    },
    carrito_actual: {
      get: function () {
        return this.carrito.filter((reserva_nodo) => {
          if (reserva_nodo.nodo_id == this.nodo_id) return true;
          else return false;
        });
      },
    },
    lista_tpv_ids() {
      let lista_ids = [];
      this.carrito.forEach((carr) => {
        if (carr.cantidad > 0 && !carr.reserva.id)
          lista_ids.push(this.parametro_padre(carr.nodo.id, "tpv_id"));
      });
      //Filter only unique
      lista_ids = lista_ids.filter((value, index, self) => {
        return self.indexOf(value) === index;
      });
      return lista_ids;
    },
    archivos() {
      var archivos = [];
      return this.archivos_padre(this.nodo_id, archivos);
    },
    extras() {
      var extras = [];
      return this.extras_padre(this.nodo_id, extras);
    },
    descripciones() {
      var descripcion = [];
      return this.descripcion_padre(this.nodo_id, descripcion).reverse();
    },
    /**
     * Esta función sirve para saber si en el nodo actual que tipo de acceso. En el caso de tener un 0, se investiga recursivamente en el nodo padre para saber si tenemos o no acceso. Esta función es buenísima! (me he subido algo arriba)
     */
    acceso() {
      if (this.nodo_id == 1) return 0;
      else {
        var nodo_seleccionado = this.nodos.filter((nodo) => {
          if (nodo.id == this.nodo_id) return true;
          else return false;
        });
        if (nodo_seleccionado.length > 0) {
          if (nodo_seleccionado[0].acceso != 0)
            return nodo_seleccionado[0].acceso;
          else return this.acceso_padre(nodo_seleccionado[0].nodo_id);
        } else return 0;
      }
    },
    acceso_socios() {
      if (this.hijos_del_padre.length == 0) {
        return false;
      } else {
        var hijos_socios = this.hijos_del_padre.filter((hijo) => {
          if (hijo.abonado) return true;
          else return false;
        });
        if (hijos_socios.length > 0) return true;
        else return false;
      }
    },
    acceso_nosocios() {
      if (this.hijos_del_padre.length == 0) {
        return false;
      } else {
        var hijos_nosocios = this.hijos_del_padre.filter((hijo) => {
          if (!hijo.abonado) return true;
          else return false;
        });
        if (hijos_nosocios.length > 0) return true;
        else return false;
      }
    },
    hijos() {
      var hijos = this.nodos.filter((nodo) => {
        if (nodo.nodo_id == this.nodo_id) return true;
        return false;
      });
      return hijos;
    },
    nodo() {
      return this.nodos.filter((nodo) => {
        if (nodo.id == this.nodo_id) return true;
        else return false;
      })[0];
    },
    /*
    fecha_inicio(){
      if(this.nodo.fecha_inicio == ''){
        return this.parametro_padre('fecha_inicio',this.nodo.nodo_id)
      }else{
        return this.nodo.fecha_inicio
      }
    },
    precio(){
      if(this.nodo.precio == ''){
        return this.parametro_padre('precio',this.nodo.nodo_id)
      }else{
        return this.nodo.precio
      }
    },
    */
  },
  created() {
    //Primero de todo obtenemos los hijos que tenga este gacho.
    this.$store.dispatch("get_hijos");
    //Nodos
    this.$store
      .dispatch("get_nodos")
      .then((data) => {
        if (typeof data !== "undefined") this.nodos = data;
      })
      .catch((error) => {
        console.log("error", error);
        if (localStorage.getItem("accessToken")) {
          // localStorage.removeItem("accessToken")
          // this.$router.push('/pages/login').catch(() => {})
        }

        // Change role on logout. Same value as initialRole of acj.js
        this.$acl.change("public");
        localStorage.removeItem("userInfo");
        localStorage.removeItem("carrito_time");
        localStorage.removeItem("carrito");
        localStorage.removeItem("vuex");
        this.$store.dispatch("vaciar_carrito").then(() => {
          localStorage.removeItem("vuex");
        });

        // this.$store.dispatch('set_loading', false);

        // this.$vs.loading.close();
        // this.$vs.notify({
        //   title:'Error',
        //   text: 'Ha habido un error de login',
        //   color:'danger'
        // });
        // setTimeout(() => {
        //   this.$vs.notify({
        //     title:'Error',
        //     text: error,
        //     color:'danger'
        //   });
        //   setTimeout(() => {
        //     // this.$router.push('/pages/login').catch(() => {})
        //   },3000)
        // },3000)
      });
    this.$store.dispatch("get_user").then((data) => {
      this.user = data;
    });
    if (typeof this.$route.params.id !== "undefined") {
      this.ir_al_nodo(this.$route.params.id);

      this.$emit("nodoinicialfalse");
    }
    this.$router.beforeEach((to, from, next) => {
      to;
      next;
      if (from.name == "home") {
        if (typeof from.params.id !== "undefined") {
          this.rutas.push(parseInt(from.params.id));
        } else {
          this.rutas.push(1);
        }
      }
      next();
    });
  },
  methods: {
    upper() {
      this.nif = this.nif.toUpperCase();
    },
    yourCallBackFunction() {},
    rpgd(index) {
      this.$store.commit("rpgd", {
        index: index,
      });
    },
    observaciones(index) {
      this.$store.commit("observaciones", {
        index: index,
        observaciones: this.carrito[index].observaciones,
      });
    },
    cantidad(index, cantidad, nodo_id) {
      let cancelar = false;
      if (this.getter_user && this.parametro_padre(nodo_id, "tpv_id") === 3) {
        if (
          !this.getter_user.titular ||
          !this.getter_user.nif ||
          this.getter_user.titular.length < 3 ||
          this.getter_user.nif.length != 9
        ) {
          if (this.nif.length !== 9 || this.titular.length < 3) {
            alert("Debes indicar tu NIF/NIE, IBAN y Titular");
            cancelar = true;
            this.$validator.validateAll("form");
          } else {
            if (cantidad !== 0) {
              //Guardamos los datos del IBAN y NIF
              if (
                this.titular !== this.getter_user.titular ||
                this.nif !== this.getter_user.nif
              ) {
                this.$store.dispatch("save_user", {
                  id: this.getter_user.id,
                  name: this.getter_user.name,
                  password: "",
                  password2: "",
                  abonado: this.getter_user.abonado,
                  telefono: this.getter_user.telefono,
                  masinfo: this.getter_user.masinfo,
                  iban: this.iban,
                  nif: this.nif,
                  titular: this.titular,
                });
              }
            }
          }
        }
      }
      if (parseInt(cantidad) === 0) cancelar = false;
      if (!cancelar) {
        this.$store.commit("cantidad", {
          cantidad: cantidad,
          index: index,
          tpv_id: this.parametro_padre(nodo_id, "tpv_id"),
        });
      }
    },
    estado(reserva_id) {
      this.$store.dispatch("estado", {
        reserva_id: reserva_id,
      });
    },
    eliminar_reserva(reserva_id) {
      this.estado(reserva_id);
      if (confirm("¿Estás seguro que quieres eliminar esta reserva?")) {
        this.$store
          .dispatch("eliminar_reserva", {
            reserva_id: reserva_id,
          })
          .then((response) => {
            response;
            this.$store.getters.reservas.forEach((reserva, reserva_index) => {
              reserva_index;
              if (reserva.id == reserva_id) {
                this.$store.getters.carrito.forEach((item, index) => {
                  item;
                  index;
                  reserva.reserva_nodos.forEach((nodo, nodo_index) => {
                    nodo_index;
                    if (
                      nodo.nodo_id == item.nodo_id &&
                      nodo.menor_id == item.menor_id
                    ) {
                      this.$store.commit("quitar_reserva", index);
                    }
                  });
                });
              }
            });
          });
      }
    },
    extra_cantidad(index, extra_index, cantidad) {
      this.$store.commit("extra_cantidad", {
        index: index,
        extra_index: extra_index,
        cantidad: cantidad,
      });
    },
    extras_padre(nodo_id, extras) {
      if (this.nodo_id == 1) return extras;
      else {
        var nodo_seleccionado = this.nodos.filter((nodo) => {
          if (nodo.id == nodo_id) return true;
          else return false;
        });
        if (nodo_seleccionado.length > 0) {
          if (nodo_seleccionado[0].extras.length > 0) {
            if (typeof nodo_seleccionado[0].extras !== "undefined")
              nodo_seleccionado[0].extras.forEach((arch) => {
                extras.push(arch);
              });
          }
          return this.extras_padre(nodo_seleccionado[0].nodo_id, extras);
        } else return extras;
      }
    },
    descripcion_padre(nodo_id, descripcion) {
      if (this.nodo_id == 1) return descripcion;
      else {
        var nodo_seleccionado = this.nodos.filter((nodo) => {
          if (nodo.id == nodo_id) return true;
          else return false;
        });
        if (nodo_seleccionado.length > 0) {
          if (nodo_seleccionado[0].descripcion != "") {
            if (typeof nodo_seleccionado[0].descripcion !== "undefined") {
              descripcion.push({
                titulo: nodo_seleccionado[0].titulo,
                descripcion: nodo_seleccionado[0].descripcion,
              });
            }
          }
          return this.descripcion_padre(
            nodo_seleccionado[0].nodo_id,
            descripcion
          );
        } else return descripcion;
      }
    },
    archivos_padre(nodo_id, archivos) {
      if (this.nodo_id == 1) return archivos;
      else {
        var nodo_seleccionado = this.nodos.filter((nodo) => {
          if (nodo.id == nodo_id) return true;
          else return false;
        });
        if (nodo_seleccionado.length > 0) {
          if (nodo_seleccionado[0].archivos.length > 0) {
            if (typeof nodo_seleccionado[0].archivos !== "undefined")
              nodo_seleccionado[0].archivos.forEach((arch) => {
                archivos.push(arch);
              });
          }
          return this.archivos_padre(nodo_seleccionado[0].nodo_id, archivos);
        } else return archivos;
      }
    },
    acceso_padre(nodo_id) {
      if (nodo_id == 1) return 0;
      else {
        var nodo_seleccionado = this.nodos.filter((nodo) => {
          if (nodo.id == nodo_id) return true;
          else return false;
        });
        if (nodo_seleccionado.length > 0) {
          if (nodo_seleccionado[0].acceso != 0)
            return nodo_seleccionado[0].acceso;
          else return this.acceso_padre(nodo_seleccionado[0].nodo_id);
        }
      }
    },
    contratar(hijo_id) {
      axios.defaults.baseURL = process.env.VUE_APP_API_URL;
      axios.defaults.headers.common["Authorization"] =
        "Bearer " + this.$store.getters["auth/token"];
      axios.post("/reserva", {
        hijo_id: hijo_id,
        nodo_id: this.nodo_id,
        rpgd: this.rpgd,
        observaciones: this.observaciones,
        fotos: this.fotos,
        montana_aviso_legal_checked: this.montana_aviso_legal_checked,
        numero_gir_dni_checked: this.numero_gir_dni_checked,
      });
    },
    get_hijos() {
      this.$store.dispatch("get_hijos").then((data) => {
        if (typeof data !== "undefined") this.hijos_del_padre = data;
        this.iniciando = false;
        this.$vs.loading.close();
      });
      this.$vs.loading.close();
    },
    precio_final_final(nodo_id) {
      var precio_final = this.precio_final(nodo_id);
      var precio_final_final = 0;
      if (precio_final[1] != "") precio_final_final = precio_final[1];
      else if (precio_final[2] != "") precio_final_final = precio_final[2];
      else if (precio_final[1] != "" || precio_final[2] != "")
        precio_final_final = precio_final[0];
      else precio_final_final = precio_final[0];
      return precio_final_final;
    },
    precio_final(nodo_id) {
      var precio_original = this.parametro_padre(nodo_id, "precio");
      var precio_descontado = "";
      var precio_penalizado = "";
      if (
        this.parametro_padre(nodo_id, "fecha_descuento") != "" &&
        this.parametro_padre(nodo_id, "precio_descuento") != ""
      ) {
        //Existe descuento
        if (this.parametro_padre(nodo_id, "fecha_descuento") > this.hoy()) {
          precio_original = this.parametro_padre(nodo_id, "precio");
          precio_descontado = this.parametro_padre(nodo_id, "precio_descuento");
          precio_penalizado = "";
        }
      }
      if (
        this.parametro_padre(nodo_id, "fecha_penalizacion") != "" &&
        this.parametro_padre(nodo_id, "precio_penalizacion") != ""
      ) {
        //Existe descuento
        if (this.parametro_padre(nodo_id, "fecha_penalizacion") < this.hoy()) {
          precio_original = this.parametro_padre(nodo_id, "precio");
          precio_descontado = "";
          precio_penalizado = this.parametro_padre(
            nodo_id,
            "precio_penalizacion"
          );
        }
      }
      return [precio_original, precio_descontado, precio_penalizado];
    },
    hoy() {
      var d = new Date();
      var month = "" + (d.getMonth() + 1);
      var day = "" + d.getDate();
      var year = d.getFullYear();

      if (month.length < 2) month = "0" + month;
      if (day.length < 2) day = "0" + day;

      return [year, month, day].join("-");
    },
    fecha_bonita(fecha) {
      return fecha.split("-").reverse().join("/");
    },
    parametro_padre(nodo_id, key) {
      if (nodo_id != 1) {
        var padre = this.nodos.filter((n) => {
          if (parseInt(n.id) === parseInt(nodo_id)) return true;
          else return false;
        })[0];
        if (
          padre &&
          padre !== undefined &&
          padre[key] !== "" &&
          padre[key] !== null
        ) {
          return padre[key];
        } else {
          if (nodo_id != 1) {
            return this.parametro_padre(padre.nodo_id, key);
          } else return "";
        }
      } else {
        return "";
      }
    },
    /*
    parametro_padre(parametro,nodo_id){
      var nodo_padre = this.nodos.filter(nodo => {
        if(nodo.id == this.nodo_id)
          return true;
        else
          return false;
      })[0]
      if(nodo_padre[parametro] == ''){
        if(nodo_id != 1)
          return parametro_padre(parametro,nodo_id)
        else{
          return ''
        }
      }else{
        return nodo_padre[parametro]
      }

    },*/
    completo(hijo) {
      // ¿Nodo lleno? Mismo criterio que el backend: máximo heredado del padre.
      // El máximo aplica también a las actividades recurrentes.
      if (!hijo || !hijo.comprable) return false;
      var maximo = this.parametro_padre(hijo.id, "maximo");
      if (maximo === "" || maximo === null || maximo === undefined)
        return false;
      return (hijo.inscritos || 0) >= parseInt(maximo);
    },
    ir(hijo) {
      this.$emit("nodoinicialfalse");
      if (hijo.comprable && this.completo(hijo)) {
        this.$vs.notify({
          title: "Completo",
          text: "Esta actividad ya no tiene plazas disponibles.",
          color: "danger",
        });
        return;
      }
      if (
        (hijo.acceso == 1 && !this.acceso_socios) ||
        (hijo.acceso == 2 && !this.acceso_nosocios)
      ) {
        hijo;
      } else {
        this.$store.commit("guardar_carrito", this.carrito);
        //Al pasar de hijo, debemos ver si es un nodo de compra. En caso afirmativo, mirar si tiene metido en el array de reservas del hijo esa reserva. Si no la tiene meterla vacia?
        this.nodo_id = hijo.id;
        if (hijo.comprable) {
          this.hijos_del_padre.forEach((hij) => {
            //Primero miramos si este nodo está dentro del carrito de compra. Ya que si está es absurdo añadirlo.
            var elementos = this.carrito.filter((reserva) => {
              if (reserva.nodo_id == this.nodo_id && reserva.menor_id == hij.id)
                return true;
              else return false;
            });
            if (elementos.length == 0) {
              var reservas_del_hijo = hij.reservas.filter((res) => {
                if (res.nodo_id == hijo.id) {
                  if (res.nodo.recurrente == 1 && res.reserva.estado == 1)
                    return false;
                  else return true;
                } else return false;
              });
              var carrito_nuevo = {};
              if (reservas_del_hijo.length > 0) {
                //Añadimos los extras en el caso de que no existan
                var res = reservas_del_hijo[0];
                this.extras.forEach((extra) => {
                  var check = res.extras.filter((res_extra) => {
                    if (res_extra.extra_id == extra.id) return true;
                    else return false;
                  });
                  if (check.length == 0) {
                    res.extra.push(extra);
                  }
                });
                /**/
                carrito_nuevo = JSON.parse(JSON.stringify(this.carrito));
                carrito_nuevo.push(res);
                this.$store.commit("guardar_carrito", carrito_nuevo);
              } else {
                var extras = [];
                this.extras.forEach((extr) => {
                  extras.push({
                    extra: extr,
                    extra_id: extr.id,
                    cantidad: 0,
                    precio_extra: extr.precio,
                    precio_total: 0,
                  });
                });
                carrito_nuevo = JSON.parse(JSON.stringify(this.carrito));
                carrito_nuevo.push({
                  nodo_id: this.nodo_id,
                  menor_id: hij.id,
                  cantidad: 0,
                  precio_nodo: this.precio_final_final(this.nodo_id),
                  precio_extras: 0,
                  precio_total: 0,
                  rpgd: false,
                  observaciones: "",
                  fotos: false,
                  montana_aviso_legal_checked: false,
                  numero_gir_dni_checked: false,
                  extras: extras,
                  hijo: hij,
                  reserva: {
                    estado: -1,
                  },
                  nodo: this.nodo,
                });
                this.$store.commit("guardar_carrito", carrito_nuevo);
              }
            }
          });
        }
      }

      this.$router.push(
        { path: `/home/${this.nodo_id}` },
        function () {
          this.internalNavigation = false;
        }.bind(this)
      );
    },
    ir_al_nodo(nodo_id) {
      this.$emit("nodoinicialfalse");
      if (nodo_id != undefined) {
        this.nodo_id = parseInt(nodo_id);
        if (this.$route.params.id != this.nodo_id)
          this.$router.push(
            { path: `/home/${this.nodo_id}` },
            function () {
              this.internalNavigation = false;
            }.bind(this)
          );
      }
    },
  },
};
</script>

<style lang="scss">
.hijos {
  .hijo {
    position: relative;
    background: white;
    margin: 20px;
    width: calc(100% - 20px);
    padding: 10px;
    border: 2px #cacaca solid;
    cursor: pointer;
    min-height: 200px;
    text-align: center;
    padding-top: 20px;
    &.completo {
      opacity: 0.55;
      border-color: #e0e0e0;
      > h5 {
        color: #d33 !important;
      }
    }
    @media (max-width: 900px) {
      width: calc(100% - 40px);
    }
    svg {
      font-size: 30px;
    }
    h4 {
      line-height: 30px;
      display: inline-block;
      margin-left: 10px;
      vertical-align: top;
    }
    > h5 {
      position: absolute;
      bottom: 8px;
      left: 0;
      color: #8cff00;
      right: 0px;
    }
    p {
      margin-top: 10px;
      margin-top: 10px;
      font-size: 14px;
      line-height: 1.5em;
      font-weight: 200;
      text-align: left;
      padding: 0px 10px;
      white-space: pre-line;
      text-align: justify !important;
    }
    br {
      display: block;
      margin: 5px 0px;
    }
    &:hover {
      border: 2px rgba(5, 140, 70, 0.48) solid;
    }
  }
}
.descripciones {
  .descripcion {
    > h4 {
    }
    > p {
      text-align: left;
      font-size: 12px;
      line-height: 1.3em;
      font-weight: 400;
      white-space: pre-line;
    }
  }
}
.rutas {
  font-size: 18px;
}
.ruticas {
  display: inline-block;
  padding-left: 15px;
  font-size: 14px;
  vertical-align: middle;
}

.contratar {
  .titulo-superior {
    font-size: 30px;
    margin-bottom: 20px;
  }
  h2 {
    margin-bottom: 10px;
  }
  .duracion {
    margin-bottom: 10px;
  }
  .descargas {
    margin-top: 20px;
  }
  .precios {
    font-size: 22px;
    padding-top: 20px;
    padding-bottom: 15px;
    display: block;
    .precio {
      color: gray;
      display: inline-block;
    }
    .precio_penalizado {
      color: #39863d;
      font-weight: 700;
      font-size: 30px;
      padding-left: 20px;
      > span {
        background: orangered;
        color: black;
        font-size: 16px;
        font-weight: 400;
        padding: 2px 5px;
        margin-left: 20px;
        display: inline-block;
        vertical-align: text-bottom;
        margin-bottom: 5px;
      }
    }
    .precio_original {
      color: gray;
      text-decoration: line-through;
      display: inline-block;
      margin-left: 20px;
      font-size: 22px;
    }
    .precio_descontado {
      color: green;
      display: inline-block;
      > span {
        background: red;
        color: white;
        font-size: 16px;
        font-weight: 400;
        padding: 2px 5px;
        margin-left: 20px;
        display: inline-block;
        vertical-align: text-bottom;
        margin-bottom: 5px;
      }
    }
  }
  .btn-contratar {
    margin-bottom: 20px;
  }
}
.archivos {
  margin-top: 20px;
  > a.archivo {
    text-align: center;
    color: #39863d;
    border-radius: 5px;
    display: inline-block;
    margin-right: 10px;
    padding: 10px;
    min-width: 100px;
    vertical-align: top;
    &:hover {
      background: #f8f8f8;
    }
    > svg {
      font-size: 36px;
    }
    > span {
      display: block;
      max-width: 150px;
    }
  }
  .hijos_del_padre {
    margin-bottom: 20px;
    .hijo_del_padre {
    }
  }
}
.not-data-table {
  display: none;
}

.message-alert-incompatible {
  margin-bottom: 57px;
  margin-top: -30px;
  min-height: 106px;
  @media (max-width: 450px) {
    min-height: 136px;
    margin-bottom: 87px;
    margin-top: -50px;
  }
  @media (max-width: 350px) {
    min-height: 176px;
    margin-bottom: 87px;
    margin-top: -50px;
  }
}
.datos-bancarios {
  background: #f6f6f6;
  border: 1px #e2e2e2 solid;
  border-radius: 10px;
  padding: 10px;
  margin-bottom: 10px;
}
</style>
